import {Inject, Injectable, NgZone} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {APP_VERSION_CONFIG} from "../../config/api";
import {HttpClient} from "@angular/common/http";
import {PopupComponent} from "../../shared/popup/popup.component";
import {PartnerService} from "../../service/partner.service";
import {ActivatedRoute, Router} from "@angular/router";
import {KioskAccessorService} from "../kiosk/kiosk-accessor.service";


@Injectable({
    providedIn: 'root'
})
export class AppVersionrService {
    private config = APP_VERSION_CONFIG;
    private isApp = +localStorage.getItem('isApp');
    private versionCount = 0;
    private versionPopupShow = false;

    constructor(private http: HttpClient,
                private router : Router,
                private activatedRoute : ActivatedRoute,
                private partnerService: PartnerService,
                private kioskAccessorService: KioskAccessorService,
                private popupComponent: PopupComponent) {

    }

    setVersionCount(count){
        localStorage.setItem('versionCount', count);
    }

    getVersionCount(){
        if(localStorage.getItem('versionCount')){
            return parseInt(localStorage.getItem('versionCount'));
        }

        return 0;

    }

    checkVersion(){
        console.log("checkVersion");

        this.getVersion().subscribe((data) => {
            var version = this.getMeta('app-version');
            if(version != data.result){
                var versionCount:number = this.getVersionCount();
                ++versionCount;
                this.setVersionCount(versionCount);

                if (this.isApp) {
                    this.upgradeKioskAppVersion();
                    //this.showUpgradePopup();
                } else {
                    this.showUpgradePopup();
                }
            }else{
                this.setVersionCount(0);
            }
        });


        let $this = this;
        setTimeout(function(){
            $this.checkVersion();
        },5*60*1000);
    }

    upgradeKioskAppVersion() {
        console.log("upgradeKioskAppVersion");
        try {
            const inputSmall = document.querySelectorAll('.login-input-small');
            const countInputSmall = inputSmall.length;
            const homeUrl = '/';

            const mascotURL = '/mascot';
            const isMascotInitialPopup = document.querySelector('.popup-login .js-phone-input');

            const currentUrl = this.router.url.split('?')[0];
            //if (currentUrl === homeUrl && !countInputSmall || currentUrl === mascotURL && isMascotInitialPopup) {
                let $this = this;
                setTimeout(function(){
                    $this.upgradeApp();
                },10000);
            //} else {
                //return;
            //}
        }catch (e) {
            this.upgradeApp();
        }
    }

    showUpgradePopup() {
        if(!this.versionPopupShow){
            this.versionPopupShow = true;

            if(this.getVersionCount() > 1){
                this.popupComponent.showPopupAgreement({
                    text: 'Please restart the application',
                    closeBtn: false,
                    showConfirmButton: false
                }, () => {
                });
            }else{
                this.popupComponent.showPopupAgreement({
                    text: this.partnerService.getName()+' version on your device is old, please update it now',
                    closeBtn: false,
                    confirmButtonText: 'Upgrade<svg><rect></rect></svg>'
                }, () => {
                    this.upgradeApp();
                });
            }
        }

    }

    getVersion() {
        return this.http.post<any>(this.config.version, {});
    }

    getMeta(metaName) {
        const metas = document.getElementsByTagName('meta');

        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') === metaName) {
                return metas[i].getAttribute('content');
            }
        }

        return '';
    }

    upgradeApp(){
        const mascotURL = '/mascot';
        const currentUrl = this.router.url.split('?')[0];
        let time = + new Date();
        //window.applicationCache.swapCache();

        window.location.href = window.location.protocol+'//'+this.getDomain(window.location.href,true)+'?hash='+time;

        // if (currentUrl === mascotURL) {
        //     const currentUrlFull = window.location.href;
        //     const queryParams = currentUrlFull.split('?')[1] ? currentUrlFull.split('?')[1] : null;
        //     const queryParamsList = queryParams ? queryParams.split('&') : [];
        //     const newQueryParamsList = [];
        //
        //     queryParamsList.forEach(param => {
        //         if (param.indexOf('hash') < 0) {
        //             newQueryParamsList.push(param);
        //         }
        //     });
        //     const newQueryParams = newQueryParamsList.length ? '&' + newQueryParamsList.join('&') : '';
        //
        //     window.location.href = window.location.protocol+'//'+this.getDomain(window.location.href,true)+ '/mascot' + '?hash='+time + newQueryParams;
        // } else {
        //     window.location.href = window.location.protocol+'//'+this.getDomain(window.location.href,true)+'?hash='+time;
        // }
    }

    getDomain(url, subdomain) {
        subdomain = subdomain || false;

        url = url.replace(/(https?:\/\/)?(www.)?/i, '');

        if (!subdomain) {
            url = url.split('.');

            url = url.slice(url.length - 2).join('.');
        }

        if (url.indexOf('/') !== -1) {
            return url.split('/')[0];
        }

        return url;
    }
}
